var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.selfVisible,"width":_vm.width,"close-on-click-modal":false,"title":_vm.title},on:{"update:visible":function($event){_vm.selfVisible=$event},"closed":_vm.close}},[_c(_vm.component,{tag:"component",attrs:{"params":_vm.params,"close":_vm.closeEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }